(function (w) {
    var app = {},
        class2type = {},
        toString = class2type.toString,
        r20 = /%20/g,
        rbracket = /\[\]$/;

    w.jqMini = app;

    app.type = function (obj) {
        if (obj == null) {
            return obj + "";
        }
        // Support: Android < 4.0, iOS < 6 (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ?
            class2type[toString.call(obj)] || "object" :
            typeof obj;
    };

    app.isFunction = function (obj) {
        return app.type(obj) === "function";
    };

    app.buildParams = function (prefix, obj, add) {
        var name, key, value;

        if (Array.isArray(obj)) {
            for (var key in obj) {
                value = obj[key]
                if (rbracket.test(prefix))
                    add(prefix, value);
                else
                    app.buildParams(prefix + "[" + (typeof value === "object" ? key : "") + "]", value, add);
            }
        } else if (app.type(obj) === 'object') {
            for (name in obj)
                app.buildParams(prefix + "[" + name + "]", obj[name], add);
        } else
            add(prefix, obj);
    };

    app.param = function (obj) {
        var prefix, key, value
        serialized = [],
            add = function (key, value) {
                value = app.isFunction(value) ? value() : (value == null ? "" : value);
                serialized[serialized.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
            };

        if (Array.isArray(obj)) {
            for (key in obj) {
                value = obj[key];
                add(key, value);
            }
        } else {
            for (prefix in obj)
                app.buildParams(prefix, obj[prefix], add);
        }

        return serialized.join('&').replace(r20, '+');
    };

})(window);

const Offer = {
    template: '<section class="work-offer is-active animate__animated" id="workOffer">'+
    '<header>'+
        '<span>Kogo szukamy?</span>'+
        '<img src="/assets/images/offers/employee.png" alt="Pracownik">'+
        '<p>{{offer.title}}</p>'+
        '<span class="location">Lokalizacja: {{offer.location}}</span>'+
    '</header>'+
    '<main class="container">'+
    '<ul>'+
        '<li>'+
            '<img src="/assets/images/offers/location.png" alt="Lokalizacja">'+
            'Lokalizacja: <span>{{offer.location}}</span>'+
        '</li>'+
        '<li>'+
            '<img src="/assets/images/offers/category.png" alt="Kategoria">'+
            'Kategoria: <span>Programowanie</span>'+
        '</li>'+
        '<li>'+
            '<img src="/assets/images/offers/position.png" alt="Stanowisko">'+
           'Stanowisko: <span>{{offer.title}}</span>'+
        '</li>'+
    '</ul>'+
    '<article class="row-sg">'+
        '<div class="sg-col-6"><div v-html="offer.description"></div>'+
        '<footer class="center">'+
        '<v-dialog v-model="dialog" width="90%" class="no-scroll">'+
            '<template v-slot:activator="{ on, attrs }">'+
                '<v-btn class="search-btn" v-on="on" v-bind="attrs" rounded dark>Aplikuj</v-btn>'+
            '</template>'+
            '<v-card><iframe :src="offer.applicationForm" frameborder="0"></iframe></v-card>'+
        '</v-dialog>'+
        '</footer></div>'+
        '<div class="sg-col-6 no-margin">'+
        '<div class="box aqua">'+
           '<h2><img src="/assets/images/offers/box-aqua.png" alt="Kropka"> Co przygotowaliśmy'+
                '<span>dla Ciebie?</span></h2>'+
                '<figure>'+
                    '<img src="/assets/images/offers/profits.png" alt="Lista profitów">'+
                '</figure>'+
        '</div>'+
        '<div class="box">'+
                '<figure v-html="offer.fc82073eafe2bfd3165db0bb1a3ac091">'+
                '</figure>'+
        '</div>'+
    '</div>'+
    '</article></main></section>'
    ,
    beforeRouteEnter(to, from, next) {
        document.querySelector("#carrier").classList.toggle("is-active");
        next(vm => {
            vm.searchOffers();
        });
    },
    beforeRouteLeave(to, from, next) {
        document.querySelector("#carrier").classList.toggle("is-active");
        next();
    },
    data: function () {
        return {
            offer: {},
            dialog: false
        };
    },
    methods: {
        goToForm: function (offer) {
            router.push({
                path: '/offer/' + offer.advertId + '/form'
            })
        },
        searchOffers: function () {
            axios
                .get('https://transitiontechnologiessoftware.traffit.com/public/an/list/?limit=100')
                .then(response => {
                    for (var i = 0; i < response.data.count; i++) {
                        if (response.data.items[i].advertId == this.$route.params.id) {
                            response.data.items[i].location = (JSON.parse(response.data.items[i].geolocation).locality == 'Koluszki') ? 'Cała Polska' : JSON.parse(response.data.items[i].geolocation).locality
                            this.offer = response.data.items[i];
                        }
                    }
                });
        }
    }
};

const Form = {
    template: '<div><iframe :src="offer.applicationForm" frameborder="0"></iframe></div>',
    beforeRouteEnter(to, from, next) {
        document.querySelector("#carrier").classList.toggle("is-active");
        next(vm => {
            vm.searchOffers();
        });
    },
    beforeRouteLeave(to, from, next) {
        document.querySelector("#carrier").classList.toggle("is-active");
        next();
    },
    data: function () {
        return {
            offer: {}
        };
    },
    methods: {
        searchOffers: function () {
            axios
                .get('https://transitiontechnologiessoftware.traffit.com/public/an/list/?limit=100')
                .then(response => {
                    for (var i = 0; i < response.data.count; i++) {
                        if (response.data.items[i].advertId == this.$route.params.id) {
                            response.data.items[i].location = (JSON.parse(response.data.items[i].geolocation).locality == 'Koluszki') ? 'Cała Polska' : JSON.parse(response.data.items[i].geolocation).locality
                            this.offer = response.data.items[i];
                        }
                    }
                });
        }
    }
};

const routes = [{
        path: '/offer/:id',
        component: Offer
    },
    {
        path: '/offer/:id/form',
        component: Form
    }
];

const router = new VueRouter({
    routes
});

new Vue({
    router,
    el: '#form',
    vuetify: new Vuetify(),
    data: function () {
        this.searchOffers();
        return {
            form: {
                query: ''
            },
            loading: true,
            valid: false,
            locations: ['Cała Polska', 'Białystok', 'Koszalin', 'Lublin', 'Ostrów Wielkopolski', 'Rzeszów', 'Warszawa', 'Praca zdalna'],
            experience: ['Praktykant', 'Junior', 'Regular', 'Senior'],
            branches: ['Administracja', 'It'],
            workOffers: [],
            offersCount: 0
        }
    },
    methods: {
        goToOffer: function (offer) {
            router.push({
                path: '/offer/' + offer.advertId,
                params: {
                    id: offer.advertId,
                    offer: offer
                }
            })
        },
        searchOffers: function () {
            this.loading = !this.loading;
            var filter = {
                filter: {
                    fields: []
                }
            }
            if (this.form && this.form.geolocation && this.form.geolocation != 'Cała Polska') {
                filter.filter.fields.push({
                    field: 'geolocation',
                    values: '%' + this.form.geolocation + '%',
                    comparision: 'like',
                    type: 'like'
                })
            }
            if (this.form && this.form.query) {
                filter.filter.query = this.form.query
            }
            axios
                .get('https://transitiontechnologiessoftware.traffit.com/public/an/list/?limit=100&' + jqMini.param(filter), )
                .then(response => {
                    this.loading = !this.loading;
                    this.offersCount = response.data.count;
                    this.workOffers = [];
                    for (var i = 0; i < response.data.count; i++) {
                        if (response.data.items[i].advertId != 68){
                            response.data.items[i].location = (JSON.parse(response.data.items[i].geolocation).locality == 'Koluszki') ? 'Cała Polska' : JSON.parse(response.data.items[i].geolocation).locality
                            this.workOffers.push(response.data.items[i]);
                        }
                    }
                });
        }
    }
}).$mount('#form');

    
